
// import { Outlet, Navigate } from "react-router-dom";
// import { useUserAccess } from "../Context/UserAccessContext";
// import { useEffect } from "react";

// const PrivateRouter = ({ menuId }) => {
//     useEffect(() => {
//         console.log("isLoggedIn:", localStorage.getItem("isLoggedIn"));
//         console.log("localStorage:", { ...localStorage });
//     }, []);

//     const { userAccess, isAccessLoaded } = useUserAccess();

//     const isLogin =
//         localStorage.getItem("isLoggedIn") === "true";


//     if (!isLogin) {
//         return <Navigate to="/" replace />;
//     }


//     // Wait for the first access check after page refresh
//     if (!isAccessLoaded) {
//         return null;
//     }


//     if (
//         menuId &&
//         !userAccess.includes(Number(menuId))
//     ) {
//         return <Navigate to="/dashboard" replace />;
//     }


//     return <Outlet />;

 
// };

// export default PrivateRouter;


import { Outlet, Navigate } from "react-router-dom";
import { useUserAccess } from "../Context/UserAccessContext";
import { useEffect, useState } from "react";

const PrivateRouter = ({ menuId }) => {
    const { userAccess, isAccessLoaded } = useUserAccess();

    const [isAuthenticated, setIsAuthenticated] = useState(
        () => localStorage.getItem("isLoggedIn") === "true"
    );

    useEffect(() => {
        const checkAuthentication = () => {
            setIsAuthenticated(
                localStorage.getItem("isLoggedIn") === "true"
            );
        };

        window.addEventListener("pageshow", checkAuthentication);
        window.addEventListener("storage", checkAuthentication);

        checkAuthentication();

        return () => {
            window.removeEventListener("pageshow", checkAuthentication);
            window.removeEventListener("storage", checkAuthentication);
        };
    }, []);

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    if (!isAccessLoaded) {
        return null;
    }

    if (
        menuId &&
        !userAccess.includes(Number(menuId))
    ) {
        return <Navigate to="/dashboard" replace />;
    }

    return <Outlet />;
};

export default PrivateRouter;
